// Notices for the brand's reviewers; a policy change summary carries no
// review, so it opens the queue itself.
export const MODERATION_REVIEW_TYPES = new Set(['moderation_review_required', 'moderation_review_overdue', 'moderation_policy_change'])

// A notice to a post's author about its moderation outcome: a brand admin's
// decision, the post rejected outright or automatically, held for review, or
// a check that failed for good.
export const MODERATION_AUTHOR_TYPES = new Set(['moderation_decision', 'moderation_rejected', 'moderation_held', 'moderation_check_failed'])

// notificationTarget is where a notification opens. Moderation review
// notices open the review in the organization's moderation queue; a
// decision, rejection, hold or failed-check notice opens the author's post
// in the editor, or, for a distributed post, its Command Center page.
export function notificationTarget(notification) {
  if (MODERATION_REVIEW_TYPES.has(notification.type)) {
    const reviewId = notification.data?.review_id
    return reviewId
      ? `/dashboard/feed/moderation?review=${encodeURIComponent(reviewId)}`
      : '/dashboard/feed/moderation'
  }
  if (MODERATION_AUTHOR_TYPES.has(notification.type)) {
    const groupId = notification.data?.group_id
    if (groupId) return `/command-center/post-groups/${encodeURIComponent(groupId)}`
    const postId = notification.data?.post_id
    return postId ? `/dashboard/feed/posts/${encodeURIComponent(postId)}/edit` : null
  }
  if (notification.type === 'approval_request' || notification.type === 'post_approval_required') {
    return '/dashboard/feed/posts?tab=pending&page=1'
  }
  if (notification.data?.post_id) {
    return `/dashboard/feed/posts/${notification.data.post_id}/edit`
  }
  return null
}

// notificationBrand is the organization a notification is about when it
// is not the one Studio is showing: { id, slug, name }, or null. The name
// comes from the viewer's organizations, else from the notice itself.
export function notificationBrand(notification, currentOrgId, organizations = []) {
  const orgId = notification?.data?.org_id
  if (!orgId || orgId === currentOrgId) return null
  const organization = (organizations || []).find((candidate) => candidate.id === orgId)
  if (organization) return { id: organization.id, slug: organization.slug, name: organization.name || organization.slug }
  const name = notification?.data?.org_name
  return name ? { id: orgId, slug: null, name } : null
}
